// ============================================================
// app.js — CLP Generator topwosk.pl
// ============================================================

let LANG = 'pl';
let currentSize = 60;
let currentConc = 8;
let _drawTimer = 0;
function drawLabelDebounced() { clearTimeout(_drawTimer); _drawTimer = setTimeout(drawLabel, 60); }

function val(id) { const el = document.getElementById(id); return el.value || el.placeholder || ''; }

function hexToRgba(hex, alpha) {
  const r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
  return `rgba(${r},${g},${b},${alpha})`;
}

// Dane etykiet CLP pochodzą wprost z DOCX-ów SBL (sds-database.js).

// Kategorie zapachów
const CAT_KEYS = {'Owocowe':'cat_owocowe','Kwiatowe':'cat_kwiatowe','Słodkie / Deserowe':'cat_slodkie','Korzenne / Orientalne':'cat_korzenne','Świeże / Zielone':'cat_swieze','Drzewne / Męskie':'cat_drzewne','Inne':'cat_inne'};
const OIL_CATEGORIES = {
  'Owocowe': [
    'Ananas i Kokos','Arbuz','Cashmere plum','Dzika Wiśnia','Mango',
    'Owoce Lasu','Pink Lemonade Spritz','Pomarańcza','Słodka Mandarynka',
    'Kokos','Truskawka','Zielone Jabłko','Raspberry Reverie'
  ],
  'Kwiatowe': [
    'Frezja','Goddess girl','Lawenda','Rose Lady','Rose petals white peach',
    'Róża','Sól morska i orchidea','Velvet Violet','Verbena orange blossom','Black Orchid & Amber','Kwiat Bzu','Dobry Sen'
  ],
  'Słodkie / Deserowe': [
    'Almond Macaron','Apple Crumble Cookies','Bourbon Vanillia','Brown sugar nad fig',
    'Caramel popcorn','Ciasteczka','Cookies strawberry crumble','Gingerbread',
    'Czekolada i ziarna kakaowe','Shea Butter Honey','Sweet pumpkin','Wanilia','Bubblegum Ballon','Karmelowe Jabłko'
  ],
  'Korzenne / Orientalne': [
    'Apple - Cinnamon','Cynamon','Mulled wine toddy','Orange spices',
    'Pomarańcza - Cynamon','Black Cardamon and Cream','Kadzidło i Mirra','Wieczór Wigilijny'
  ],
  'Świeże / Zielone': [
    'California dreaming','Czysta bawełna','Green Tea','Happy life',
    'Lemon and mint','Matcha and bergamot','Nordic fir firewood',
    'Warm summer breeze','White Sage','Calamansi & Coriander','Citronella','Kwiat Konopi','Matcha Tea & Wild Honey','Świeża Pościel'
  ],
  'Drzewne / Męskie': [
    'Bergamot Patchouli','Cedarwood Vanilla','Drzewo sandałowe',
    'Gentle Masculine','High class dark musk',
    'Palo santo and sandalwood','Palo santo vibe','Rich amber','Velvet tobacco','Gabinet Dżentelmena','Toskańska Skóra'
  ],
  'Inne': [
    'Angelic Fantasy','Gin Tonic','Kawa','Niezwykły'
  ]
};

// GHS pictogram images
const GHS_IMG = {};
let _ghsLoaded = 0;
const GHS_FILES = [
  ['flame','GHS02'],
  ['oxidizer','GHS03'],
  ['corrosion','GHS05'],
  ['exclamation','GHS07'],
  ['health','GHS08'],
  ['environment','GHS09']
];
function _clpGhsUrl(ghsKey, file) {
  if (window.CLP_ASSETS && window.CLP_ASSETS.ghs && window.CLP_ASSETS.ghs[ghsKey]) {
    return window.CLP_ASSETS.ghs[ghsKey];
  }
  return 'assets/pictograms/' + file + '.png';
}
GHS_FILES.forEach(([name, file]) => {
  const img = new Image();
  img.onload = () => { _ghsLoaded++; if (_ghsLoaded >= GHS_FILES.length) drawLabelDebounced(); };
  img.src = _clpGhsUrl(name, file);
  GHS_IMG[name] = img;
});

document.addEventListener('DOMContentLoaded', () => {
  applyTranslations();
  buildDropdown('');
  buildPictoGrid();
  drawLabel();
  bindEvents();
  TWAnalytics.track('tw_clp_loaded', { language: LANG, size_mm: currentSize });
});

// ── TŁUMACZENIA ───────────────────────────────────────────
function tr(key) {
  return (T[LANG] && T[LANG][key]) || T.pl[key] || key;
}
function applyTranslations() {
  document.querySelectorAll('[data-t]').forEach(el => {
    el.textContent = tr(el.getAttribute('data-t'));
  });
  document.querySelectorAll('[data-t-label]').forEach(el => {
    el.label = tr(el.getAttribute('data-t-label'));
  });
  const fs = document.getElementById('fragSearch');
  if (fs) fs.placeholder = tr('frag_placeholder');
  const pn = document.getElementById('productName');
  if (pn) pn.placeholder = tr('product_placeholder');
}

// ── ZDARZENIA ─────────────────────────────────────────────
function bindEvents() {
  document.querySelectorAll('.lang-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.lang-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      LANG = btn.dataset.lang;
      applyTranslations();
      reapplyCurrentOil();
      TWAnalytics.track('tw_clp_lang_switched', { language: LANG });
    });
  });

  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      currentSize = parseInt(btn.dataset.size, 10);
      updateArt29Option();
      updateSizeWarning();
      resizeCanvas();
      drawLabel();
      TWAnalytics.track('tw_clp_size_changed', { size_mm: currentSize, language: LANG });
    });
  });

  const ptSel = document.getElementById('productType');
  if (ptSel) {
    ptSel.addEventListener('change', () => {
      const [, conc] = ptSel.value.split(':');
      currentConc = parseInt(conc, 10);
      reapplyCurrentOil();
    });
  }

  document.getElementById('btnRefresh').addEventListener('click', drawLabel);
  document.getElementById('btnPng').addEventListener('click', () => downloadAs('png'));
  document.getElementById('btnSvg').addEventListener('click', () => downloadAs('svg'));
  document.getElementById('btnPdf').addEventListener('click', () => downloadAs('pdf'));
  document.getElementById('btnKch').addEventListener('click', downloadKch);

  ['productName','mass','unit','batchNum','ufi','bizName','bizAddr','bizPhone','bizEmail','bizWww','bgColor','textColor']
    .forEach(id => { const el = document.getElementById(id); if (el) el.addEventListener('input', drawLabelDebounced); });
  const prefixEl = document.getElementById('bizPhonePrefix');
  if (prefixEl) prefixEl.addEventListener('change', drawLabelDebounced);

  // Phone: tylko cyfry i spacje, auto-grupowanie 3-3-3
  const phoneEl = document.getElementById('bizPhone');
  if (phoneEl) {
    phoneEl.addEventListener('input', () => {
      const digits = phoneEl.value.replace(/\D/g, '').substring(0, 15);
      const groups = [];
      for (let i = 0; i < digits.length; i += 3) groups.push(digits.substring(i, i + 3));
      phoneEl.value = groups.join(' ');
      phoneEl.classList.toggle('invalid', digits.length > 0 && digits.length < 6);
    });
  }

  // Email: walidacja formatu
  const emailEl = document.getElementById('bizEmail');
  if (emailEl) {
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    emailEl.addEventListener('input', () => {
      const v = emailEl.value.trim();
      emailEl.classList.toggle('invalid', v.length > 0 && !emailRe.test(v));
    });
  }

  // UFI auto-format: XXXX-XXXX-XXXX-XXXX
  const ufiEl = document.getElementById('ufi');
  if (ufiEl) {
    ufiEl.addEventListener('input', () => {
      const cur = ufiEl.selectionStart;
      const before = ufiEl.value.substring(0, cur).replace(/[^A-Za-z0-9]/g, '').length;
      const raw = ufiEl.value.replace(/[^A-Za-z0-9]/g, '').substring(0, 16).toUpperCase();
      const parts = raw.match(/.{1,4}/g) || [];
      ufiEl.value = parts.join('-');
      // map alphanumeric count back to formatted position
      let count = 0, newPos = 0;
      for (let i = 0; i < ufiEl.value.length; i++) {
        if (ufiEl.value[i] !== '-') count++;
        if (count >= before) { newPos = i + 1; break; }
      }
      if (count < before) newPos = ufiEl.value.length;
      ufiEl.setSelectionRange(newPos, newPos);
    });
  }

  const omitPEl = document.getElementById('omitP');
  if (omitPEl) omitPEl.addEventListener('change', drawLabel);

  ['fsName','fsHp','fsCompany','fsPicto'].forEach(id => {
    const sl = document.getElementById(id);
    if (!sl) return;
    sl.addEventListener('input', () => drawLabel());
    sl.addEventListener('mousedown', () => { sl.closest('.font-size-row').classList.add('slider-dragging'); });
  });
  window.addEventListener('mouseup', () => {
    document.querySelectorAll('.font-size-row.slider-dragging').forEach(row => row.classList.remove('slider-dragging'));
  });
  ['offName','offHp','offCompany','offPicto','offGhs'].forEach(id => {
    const sl = document.getElementById(id);
    if (sl) sl.addEventListener('input', () => {
      document.getElementById(id + 'Val').textContent = sl.value;
      drawLabel();
    });
  });

  // Klikalne wartości mm → edytowalne pole
  const fontSliderMap = {fsName:17, fsHp:5, fsCompany:7};
  Object.entries(fontSliderMap).forEach(([sliderId, mult]) => {
    const valSpan = document.getElementById(sliderId + 'Val');
    const slider = document.getElementById(sliderId);
    if (!valSpan || !slider) return;
    valSpan.classList.add('mm-clickable');
    valSpan.addEventListener('click', () => {
      const currentMm = parseFloat(valSpan.textContent);
      const input = document.createElement('input');
      input.type = 'number';
      input.step = '0.05';
      input.min = '0.1';
      input.value = currentMm || '';
      input.className = 'mm-edit-input';
      valSpan.textContent = '';
      valSpan.appendChild(input);
      input.focus();
      input.select();
      const commit = () => {
        const mmVal = parseFloat(input.value);
        if (mmVal > 0) {
          const basePxMap = {40:214, 50:267, 60:320, 80:427, 100:534};
          const basePx = basePxMap[currentSize] || 320;
          const newSlider = Math.round(mmVal * 100 / (mult * currentSize / basePx * 0.53));
          slider.value = Math.max(+slider.min, Math.min(+slider.max, newSlider));
        }
        drawLabel();
      };
      input.addEventListener('blur', commit);
      input.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    });
  });

  document.getElementById('cutLine').addEventListener('change', drawLabel);
  document.querySelectorAll('.ghsCb').forEach(cb => cb.addEventListener('change', () => {
    updateGhsSlidersVisibility();
    drawLabel();
  }));
  document.querySelectorAll('[name=shape]').forEach(r => r.addEventListener('change', () => { resizeCanvas(); drawLabel(); }));
  document.querySelectorAll('[name=companyLayout]').forEach(r => r.addEventListener('change', drawLabel));
  document.querySelectorAll('[name=productLayout]').forEach(r => r.addEventListener('change', drawLabel));

  const relocateCompliance = () => {
    const el = document.getElementById('clpCompliance');
    if (!el) return;
    const panel = document.getElementById('appearancePanel');
    const preview = document.querySelector('.preview-canvas');
    const btnRow = panel && panel.querySelector('.btn-row');
    if (window.innerWidth <= 1200) {
      if (btnRow && el.parentElement !== panel) panel.insertBefore(el, btnRow);
    } else {
      if (preview && el.parentElement !== preview) preview.appendChild(el);
    }
  };
  relocateCompliance();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => { relocateCompliance(); drawLabel(); }, 120);
  });

  const panel = document.getElementById('appearancePanel');
  const btnToggle = document.getElementById('btnToggleAppearance');
  const btnClose = document.getElementById('btnCloseAppearance');
  const syncHeaderVar = () => {
    const h = document.querySelector('.app-header');
    if (h) document.documentElement.style.setProperty('--hdr-h', h.offsetHeight + 'px');
  };
  const openPanel = () => {
    syncHeaderVar();
    panel.classList.add('is-open');
    document.body.classList.add('panel-open');
    window.scrollTo({ top: 0, behavior: 'instant' });
    requestAnimationFrame(() => drawLabel());
  };
  const closePanel = () => {
    panel.classList.remove('is-open');
    document.body.classList.remove('panel-open');
    requestAnimationFrame(() => drawLabel());
  };
  btnToggle.addEventListener('click', openPanel);
  btnClose.addEventListener('click', closePanel);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
  });


  const fs = document.getElementById('fragSearch');
  fs.addEventListener('input', () => {
    document.getElementById('productName').placeholder = fs.value;
    buildDropdown(fs.value);
    drawLabelDebounced();
  });
  fs.addEventListener('focus', () => { fs.select(); buildDropdown(''); });
  document.addEventListener('click', e => {
    if (!e.target.closest('.search-wrap')) {
      document.getElementById('fragDD').classList.remove('open');
      document.body.classList.remove('dropdown-open');
    }
  });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateDropdownHeight);
  }
}

// ── DROPDOWN ──────────────────────────────────────────────

function updateDropdownHeight() {
  const dd = document.getElementById('fragDD');
  if (!dd || !dd.classList.contains('open')) return;
  const input = document.getElementById('fragSearch');
  if (!input) return;
  const inputRect = input.getBoundingClientRect();
  const vpHeight = (window.visualViewport ? window.visualViewport.height : window.innerHeight);
  const spaceBelow = vpHeight - inputRect.bottom - 8;
  dd.style.maxHeight = Math.max(100, Math.min(240, spaceBelow)) + 'px';
}
function _clpClassifyScenario(data) {
  if (!data) return 'clean';
  const hasH = (data.h || '').trim().length > 0;
  const hasContains = (data.contains || '').trim().length > 0;
  if (!hasH) return hasContains ? 'euh208_only' : 'clean';
  const healthPictos = (data.pictos || []).filter(p => p !== 'environment');
  if (healthPictos.length === 0) return 'env_only';
  return 'bad';
}

function oilMarkerLevel(name) {
  const oil = DB[name];
  if (!oil || !oil.conc) return 'clean';
  let hasBad = false, hasLabel = false;
  for (const c of [6, 8, 10]) {
    const data = oil.conc[c] && (oil.conc[c][LANG] || oil.conc[c].pl);
    if (!data) continue;
    const s = _clpClassifyScenario(data);
    if (s === 'bad') { hasBad = true; break; }
    if (s === 'euh208_only' || s === 'env_only') hasLabel = true;
  }
  if (hasBad) return 'pcn';
  if (hasLabel) return 'euh208';
  return 'clean';
}

function buildDropdown(query) {
  const dd = document.getElementById('fragDD');
  dd.innerHTML = '';
  const q = query.toLowerCase().trim();

  if (!document.activeElement || document.activeElement.id !== 'fragSearch') {
    dd.classList.remove('open'); return;
  }

  let hasItems = false;
  const catOrder = Object.keys(OIL_CATEGORIES);
  const current = (document.getElementById('fragSearch').value || '').trim();
  let selectedEl = null;

  catOrder.forEach(cat => {
    const oils = (OIL_CATEGORIES[cat] || [])
      .filter(name => DB[name] && (!q || name.toLowerCase().includes(q)))
      .sort((a, b) => a.localeCompare(b, 'pl'));
    if (!oils.length) return;

    const header = document.createElement('div');
    header.className = 'dd-cat';
    header.textContent = CAT_KEYS[cat] ? tr(CAT_KEYS[cat]) : cat;
    dd.appendChild(header);

    oils.forEach(name => {
      const item = document.createElement('div');
      item.className = 'dd-item' + (name === current ? ' selected' : '');
      const level = oilMarkerLevel(name);
      const nameSpan = document.createElement('span');
      nameSpan.className = 'dd-item-name';
      nameSpan.textContent = name;
      item.appendChild(nameSpan);
      if (level !== 'clean') {
        const badge = document.createElement('span');
        badge.className = 'dd-badge dd-badge--' + level;
        badge.textContent = level === 'pcn' ? 'PCN' : 'EUH208';
        badge.title = tr(level === 'pcn' ? 'badge_pcn_tooltip' : 'badge_euh208_tooltip');
        item.appendChild(badge);
      }
      item.addEventListener('mousedown', e => { e.preventDefault(); selectOil(name, DB[name]); });
      dd.appendChild(item);
      if (name === current) selectedEl = item;
      hasItems = true;
    });
  });

  if (hasItems) dd.classList.add('open');
  else dd.classList.remove('open');
  document.body.classList.toggle('dropdown-open', dd.classList.contains('open'));
  if (selectedEl && hasItems) selectedEl.scrollIntoView({ block: 'center' });
  updateDropdownHeight();
}

function selectOil(name, data) {
  const fs = document.getElementById('fragSearch');
  fs.value = name;
  fs.blur();
  document.getElementById('fragDD').classList.remove('open');
  document.body.classList.remove('dropdown-open');
  document.getElementById('productName').placeholder = name;
  TWAnalytics.track('tw_clp_oil_selected', { oil_name: name, language: LANG });
  const canvas = document.getElementById('labelCanvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.classList.add('flash');
    setTimeout(() => { applyOilData(name, data); canvas.classList.remove('flash'); }, 180);
  } else {
    applyOilData(name, data);
  }
}

function applyOilData(name, data) {
  const hEl = document.getElementById('hPhrases');
  const pEl = document.getElementById('pPhrases');
  const euhEl = document.getElementById('euhPhrases');
  const lang = (LANG === 'pl' || LANG === 'en') ? LANG : 'en';

  if (!data || !data.conc) {
    hEl.value = ''; pEl.value = ''; euhEl.value = '';
    document.getElementById('containsField').value = '';
    document.getElementById('signalHidden').value = 'none';
    document.querySelectorAll('.ghsCb').forEach(cb => { cb.checked = false; });
  } else {
    const concData = data.conc[currentConc] || data.conc[Object.keys(data.conc)[0]];
    const ld = concData[lang] || concData.pl || concData.en;

    euhEl.value = ld.contains || '';
    hEl.value = ld.h || '';
    pEl.value = ld.p || '';
    document.getElementById('containsField').value = '';
    document.getElementById('signalHidden').value = ld.signal || 'none';
    const pictos = ld.pictos || [];
    document.querySelectorAll('.ghsCb').forEach(cb => {
      cb.checked = pictos.includes(cb.value);
    });
  }
  const ufiWrap = document.getElementById('ufiWrap');
  if (ufiWrap) ufiWrap.style.display = document.querySelectorAll('.ghsCb:checked').length > 0 ? '' : 'none';

  // Auto-select default EN 15494 pictograms (fire safety)
  const defaultPictos = [
    'warning',
    'Nigdy nie zostawiaj płonącej świecy bez nadzoru',
    'Świece należy palić poza zasięgiem przedmiotów łatwopalnych',
    'Przechowywać świece poza zasięgiem dzieci i zwierząt domowych.',
  ];
  defaultPictos.forEach(name => {
    if (!selectedPictos.has(name)) {
      selectedPictos.add(name);
      const item = document.querySelector(`.picto-item[data-picto="${name}"]`);
      if (item) item.classList.add('selected');
    }
  });
  const pictoWrap = document.getElementById('pictoSlidersWrap');
  if (pictoWrap) pictoWrap.style.display = selectedPictos.size > 0 ? '' : 'none';

  updateBanners(name);
  updateGhsSlidersVisibility();
  updateKchButton();
  drawLabel();
}

function reapplyCurrentOil() {
  const name = document.getElementById('fragSearch').value;
  const data = DB[name];
  if (data) applyOilData(name, data);
  else drawLabel();
  updateKchButton();
}

function normKch(s) {
  return s.toLowerCase().replace(/ł/g,'l').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]/g,'');
}

function findKchFile(fragName, conc, lang) {
  if (!fragName || !conc || typeof KCH_FILES === 'undefined') return null;
  const searchLang = (lang === 'pl') ? 'pl' : 'en';
  const target = normKch(fragName) + conc + searchLang;
  for (const f of KCH_FILES) {
    const n = normKch(f);
    if (n.endsWith('pdf') && n.includes(target)) return f;
  }
  return null;
}

function updateKchButton() {
  const btn = document.getElementById('btnKch');
  const row = document.getElementById('kchRow');
  const nameEl = document.getElementById('kchFilename');
  if (!btn || !row) return;
  const ptSel = document.getElementById('productType');
  const fragName = document.getElementById('fragSearch').value;
  const isCandle = ptSel && ptSel.value.startsWith('candle:');
  const file = isCandle ? findKchFile(fragName, currentConc, LANG) : null;
  row.style.display = file ? '' : 'none';
  btn.dataset.file = file || '';
  if (nameEl) nameEl.textContent = file || '';
}

const KCH_CACHE_BUST = '20261016b';

function downloadKch() {
  const btn = document.getElementById('btnKch');
  const file = btn && btn.dataset.file;
  if (!file) return;
  const oilName = (document.getElementById('fragSearch') || {}).value || '';
  TWAnalytics.track('tw_clp_kch_downloaded', { oil_name: oilName, file: file, language: LANG });
  const base = (window.CLP_ASSETS && window.CLP_ASSETS.kchBase) || 'assets/kch/';
  // Cache-buster for the Shopify CDN: PDFs replaced under the same filename stay cached
  // for up to a year under the bare URL. Bump KCH_CACHE_BUST whenever any KCH PDF is re-uploaded.
  const bust = /^(https?:)?\/\//.test(base) ? '?v=' + KCH_CACHE_BUST : '';
  window.open(base + encodeURIComponent(file) + bust, '_blank');
}

function isArt29Applicable() {
  const el = document.getElementById('mass');
  const massVal = parseFloat(el.value);
  if (isNaN(massVal) || massVal <= 0) return currentSize < 74;
  return massVal <= 125;
}

function updateArt29Option() {
  const wrap = document.getElementById('art29Option');
  if (!wrap) return;
  const isArt29 = isArt29Applicable();
  wrap.style.display = isArt29 ? '' : 'none';
  if (!isArt29) document.getElementById('omitP').checked = false;
}

function updateSizeWarning() {
  const maxVal = currentSize >= 80 ? 364 : 260;
  ['fsHp','fsCompany'].forEach(id => {
    const sl = document.getElementById(id);
    if (sl) sl.max = maxVal;
  });
  const slName = document.getElementById('fsName');
  if (slName) slName.max = currentSize >= 80 ? 714 : 260;

  const offRange = currentSize >= 100 ? 170 : currentSize >= 80 ? 130 : 70;
  ['offName','offHp','offCompany','offPicto'].forEach(id => {
    const sl = document.getElementById(id);
    if (sl) {
      sl.min = -offRange; sl.max = offRange;
      if (parseInt(sl.value) > offRange) sl.value = offRange;
      if (parseInt(sl.value) < -offRange) sl.value = -offRange;
    }
  });
  const slGhs = document.getElementById('offGhs');
  if (slGhs) {
    const gMin = currentSize >= 100 ? -250 : currentSize >= 80 ? -180 : -105;
    const gMax = currentSize >= 100 ? 300 : currentSize >= 80 ? 250 : 150;
    slGhs.min = gMin; slGhs.max = gMax;
    if (parseInt(slGhs.value) > gMax) slGhs.value = gMax;
    if (parseInt(slGhs.value) < gMin) slGhs.value = gMin;
  }
}

function updateGhsSlidersVisibility() {
  const any = document.querySelectorAll('.ghsCb:checked').length > 0;
  const wrap = document.getElementById('ghsSlidersWrap');
  if (wrap) wrap.style.display = any ? '' : 'none';
}

function updateBanners(name) {
  const isNoSds = NO_SDS.includes(name) && name !== '';
  const noEl = document.getElementById('noSdsBanner');
  noEl.style.display = isNoSds ? 'block' : 'none';
  noEl.textContent = tr('no_sds');
}


// ── PIKTOGRAMY EN 15494 ──────────────────────────────────
const EN15494_PICTOS = [
  'warning',
  'Nigdy nie zostawiaj płonącej świecy bez nadzoru',
  'Świece należy palić poza zasięgiem przedmiotów łatwopalnych',
  'Przechowywać świece poza zasięgiem dzieci i zwierząt domowych.',
  'Zawsze używaj odpowiedniego świecznika lub podstawki',
  'Używać odpowiedniego pojemnika wypełnionego wodą',
  'Zachować minimalny odstęp między palącymi się świecami.',
  'Unikać przeciągów',
  'Nie umieszczać świec w pobliżu źródeł ciepła',
  'Świece należy palić w pozycji pionowej',
  'Przyciąć knot na wysokość około x cm przed zapaleniem świecy',
  'Zawsze używaj gasidła do świec. Nie zdmuchuj płomienia',
  'Utrzymywać basen płynnego wosku wolny od zapałek i innych zanieczyszczeń',
  'Nie przenosić zapalonej świecy',
  'Nigdy nie używaj płynu do gaszenia świecy',
  'Nie używać w kominkach zapachowych',
  'Naczynie może się nagrzewać. Nie dotykać podczas palenia.',
  'Używać odpowiedniego pojemnika, ponieważ te świece upłynniają się podczas palenia',
  'Używać wyłącznie w podgrzewaczach z odpowiednią wentylacją',
  'Przycinać krawędź świecy do wysokości około x cm',
  'Przed zapaleniem świecy należy usunąć opakowanie i etykiety',
];
const PICTO_VISIBLE = 5;
const pictoImages = {};
const selectedPictos = new Set();

function buildPictoGrid() {
  const grid = document.getElementById('pictoGrid');
  grid.innerHTML = '';

  EN15494_PICTOS.forEach((name, i) => {
    const src = (window.CLP_ASSETS && window.CLP_ASSETS.picto && window.CLP_ASSETS.picto[name])
      || `assets/pictograms/${name}.svg`;
    const item = document.createElement('div');
    item.className = 'picto-item' + (i >= PICTO_VISIBLE ? ' picto-hidden' : '');
    item.dataset.picto = name;

    const img = new Image();
    img.src = src;
    img.alt = name.replace(/_/g, ' ');
    img.onload = () => { pictoImages[name] = img; };
    item.appendChild(img);

    item.addEventListener('click', () => {
      if (selectedPictos.has(name)) {
        selectedPictos.delete(name);
        item.classList.remove('selected');
      } else {
        selectedPictos.add(name);
        item.classList.add('selected');
      }
      drawLabel();
      const wrap = document.getElementById('pictoSlidersWrap');
      if (wrap) wrap.style.display = selectedPictos.size > 0 ? '' : 'none';
    });

    grid.appendChild(item);
  });

  // Przycisk "pokaż więcej"
  const toggle = document.createElement('div');
  toggle.className = 'picto-toggle';
  toggle.textContent = '+ ' + tr('picto_show_more');
  toggle.addEventListener('click', () => {
    const willExpand = toggle.dataset.expanded !== '1';
    grid.querySelectorAll('.picto-item').forEach((el, i) => {
      if (i >= PICTO_VISIBLE) el.classList.toggle('picto-hidden', !willExpand);
    });
    toggle.dataset.expanded = willExpand ? '1' : '0';
    toggle.textContent = willExpand ? '− ' + tr('picto_show_less') : '+ ' + tr('picto_show_more');
  });
  grid.after(toggle);
}

// ── CANVAS ────────────────────────────────────────────────
function resizeCanvas() {
  // bufor canvasa jest ustawiany w drawLabel()
}

function getSignalWord() {
  const val = document.getElementById('signalHidden').value || '';
  if (val === 'warning') return tr('signal_warning_label');
  if (val === 'danger')  return tr('signal_danger_label');
  return '';
}

// roundRect polyfill for older browsers
if (typeof CanvasRenderingContext2D !== 'undefined' && !CanvasRenderingContext2D.prototype.roundRect) {
  CanvasRenderingContext2D.prototype.roundRect = function(x, y, w, h, r) {
    if (typeof r === 'number') r = [r, r, r, r];
    const [tl, tr2, br, bl] = r;
    this.moveTo(x + tl, y);
    this.lineTo(x + w - tr2, y); this.arcTo(x + w, y, x + w, y + tr2, tr2);
    this.lineTo(x + w, y + h - br); this.arcTo(x + w, y + h, x + w - br, y + h, br);
    this.lineTo(x + bl, y + h); this.arcTo(x, y + h, x, y + h - bl, bl);
    this.lineTo(x, y + bl); this.arcTo(x, y, x + tl, y, tl);
    this.closePath();
  };
}

function drawArcText(ctx, text, cx, cy, radius) {
  const chars = text.split('');
  const widths = chars.map(ch => ctx.measureText(ch).width);
  const totalW = widths.reduce((s, w) => s + w, 0);
  const angleSpan = totalW / radius;
  let angle = -Math.PI / 2 - angleSpan / 2;

  ctx.save();
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  chars.forEach((ch, i) => {
    angle += widths[i] / 2 / radius;
    const x = cx + Math.cos(angle) * radius;
    const y = cy + Math.sin(angle) * radius;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle + Math.PI / 2);
    ctx.fillText(ch, 0, 0);
    ctx.restore();
    angle += widths[i] / 2 / radius;
  });
  ctx.restore();
}

function drawArcTextBottom(ctx, text, cx, cy, radius) {
  const chars = text.split('');
  const widths = chars.map(ch => ctx.measureText(ch).width);
  const totalW = widths.reduce((s, w) => s + w, 0);
  const angleSpan = totalW / radius;
  let angle = Math.PI / 2 + angleSpan / 2;

  ctx.save();
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  chars.forEach((ch, i) => {
    angle -= widths[i] / 2 / radius;
    const x = cx + Math.cos(angle) * radius;
    const y = cy + Math.sin(angle) * radius;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle - Math.PI / 2);
    ctx.fillText(ch, 0, 0);
    ctx.restore();
    angle -= widths[i] / 2 / radius;
  });
  ctx.restore();
}

function breakLongWord(ctx, word, maxW) {
  if (ctx.measureText(word).width <= maxW) return [word];
  const parts = [];
  let cur = '';
  for (const ch of word) {
    const t = cur + ch;
    if (ctx.measureText(t).width > maxW && cur) { parts.push(cur); cur = ch; }
    else cur = t;
  }
  if (cur) parts.push(cur);
  return parts;
}

function wrapText(ctx, text, x, y, maxW, lh) {
  const rawWords = text.split(' ');
  const words = [];
  rawWords.forEach(w => { breakLongWord(ctx, w, maxW).forEach(p => words.push(p)); });
  let line = '', n = 0;
  words.forEach(w => {
    const t = line ? line + ' ' + w : w;
    if (ctx.measureText(t).width > maxW && line) { ctx.fillText(line, x, y + n*lh); n++; line = w; }
    else line = t;
  });
  if (line) { ctx.fillText(line, x, y + n*lh); n++; }
  return n;
}

// Wrap text with variable width — narrow beside pictogram, full below it
function wrapTextFlow(ctx, text, y, lh, narrowLeft, narrowRight, fullLeft, fullRight, pictoBottom) {
  if (!text) return 0;
  const minMaxW = Math.min(narrowRight - narrowLeft, fullRight - fullLeft);
  const rawWords = text.split(' ');
  const words = [];
  rawWords.forEach(w => { breakLongWord(ctx, w, minMaxW).forEach(p => words.push(p)); });
  let line = '', n = 0;
  const getW = (cy) => cy < pictoBottom ? { l: narrowLeft, r: narrowRight } : { l: fullLeft, r: fullRight };
  words.forEach(w => {
    const bounds = getW(y + n * lh);
    const maxW = bounds.r - bounds.l;
    const t = line ? line + ' ' + w : w;
    if (ctx.measureText(t).width > maxW && line) {
      const b = getW(y + n * lh);
      ctx.fillText(line, (b.l + b.r) / 2, y + n * lh);
      n++; line = w;
    } else line = t;
  });
  if (line) {
    const b = getW(y + n * lh);
    ctx.fillText(line, (b.l + b.r) / 2, y + n * lh);
    n++;
  }
  return n;
}

function drawLabel() {
  updateArt29Option();
  updateSizeWarning();
  const canvas = document.getElementById('labelCanvas');
  const dpr = Math.max(window.devicePixelRatio || 1, 3);
  const isMobile = window.innerWidth <= 1200;
  let displayPx;
  if (isMobile) {
    const vw = window.innerWidth;
    const vh = window.visualViewport?.height || window.innerHeight;
    const panelOpen = document.body.classList.contains('panel-open');
    const mobileRatios = {40:0.78, 50:0.86, 60:0.93, 80:1.0, 100:1.0};
    const mobileRatio = mobileRatios[currentSize] || 0.93;
    let base;
    if (panelOpen) {
      const availH = vh - vh * 0.55 - 16;
      base = Math.max(160, Math.min(vw - 16, availH));
    } else if (vw >= 768) {
      base = Math.min(vw, 440, vh * 0.6);
    } else {
      base = Math.min(vw, vh * 0.78);
    }
    displayPx = Math.round(base * mobileRatio);
  } else {
    const colWidth = canvas.parentElement.getBoundingClientRect().width;
    const availH = window.innerHeight - 100;
    const sizeRatios = {40:0.7, 50:0.82, 60:0.94, 80:1.0, 100:1.0};
    const sizeRatio = sizeRatios[currentSize] || 0.94;
    const hardCap = window.innerWidth >= 1600 ? 700 : 1400;
    displayPx = Math.round(Math.min(colWidth * sizeRatio, availH, hardCap));
  }
  const buf = Math.round(displayPx * dpr);
  canvas.style.width = displayPx + 'px';
  canvas.style.height = displayPx + 'px';
  canvas.width = buf;
  canvas.height = buf;
  const W = displayPx, H = displayPx;
  const ctx = canvas.getContext('2d');
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  const bg = document.getElementById('bgColor').value;
  const tc = document.getElementById('textColor').value;
  const fsName = (parseInt(document.getElementById('fsName').value, 10) || 100) / 100;
  const fsHp = (parseInt(document.getElementById('fsHp').value, 10) || 100) / 100;
  const fsCompany = (parseInt(document.getElementById('fsCompany').value, 10) || 100) / 100;
  const shape = (document.querySelector('[name=shape]:checked') || {}).value || 'circle';
  const pictos = [...document.querySelectorAll('.ghsCb:checked')].map(c => c.value);
  const basePxMap = {40:214, 50:267, 60:320, 80:427, 100:534};
  const basePx = basePxMap[currentSize] || 320;
  const sc = W / basePx;
  const pad = Math.round(18 * sc);
  const offName = (parseInt(document.getElementById('offName').value, 10) || 0) * sc;
  const offHp = (parseInt(document.getElementById('offHp').value, 10) || 0) * sc;
  const offCompany = (parseInt(document.getElementById('offCompany').value, 10) || 0) * sc;

  ctx.clearRect(0, 0, W, H);
  ctx.save();

  if (shape === 'circle') {
    ctx.beginPath(); ctx.arc(W/2, H/2, W/2-2, 0, Math.PI*2); ctx.clip();
  } else {
    ctx.beginPath(); ctx.roundRect(2, 2, W-4, H-4, 6*sc); ctx.clip();
  }

  ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);

  // ── Parametry sekcji ──
  const offGhs = (parseInt(document.getElementById('offGhs').value, 10) || 0) * sc;
  const massVal = parseFloat(document.getElementById('mass').value) || 0;
  const unitVal = document.getElementById('unit').value;
  const capacityL = (unitVal === 'ml') ? massVal / 1000 : massVal / 1000;
  const minGhsMm = capacityL > 500 ? 46 : capacityL > 50 ? 32 : capacityL > 3 ? 23 : 10;
  const minIconPx = Math.ceil(minGhsMm * W / currentSize);
  const proportionalPx = Math.round(W * 0.15);
  const iconSize = Math.max(minIconPx, proportionalPx);
  const iconGap  = Math.round(4*sc);
  const hasIcons = pictos.length > 0;
  const flowLayout = currentSize <= 50 && hasIcons; // małe etykiety: GHS po lewej, tekst opływa
  const leftPictos = flowLayout ? [] : pictos.slice(0, 3);
  const rightPictos = flowLayout ? [] : pictos.slice(3, 6);
  const sideMargin = (!flowLayout && hasIcons) ? iconSize + Math.round(6*sc) : 0;
  const ghsColW = flowLayout ? (iconSize + Math.round(4*sc)) : 0;
  const ghsBottomBuffer = Math.round(6*sc);
  const textLeft = pad + sideMargin;
  const textRight = W - pad - sideMargin;
  const textW = textRight - textLeft;
  const textCx = (textLeft + textRight) / 2;
  // Flow layout bounds
  const flowNarrowLeft = pad + ghsColW;
  const flowNarrowRight = W - pad;
  const flowFullLeft = pad;
  const flowFullRight = W - pad;
  const fsPicto = (parseInt(document.getElementById('fsPicto').value, 10) || 100) / 100;
  const offPicto = (parseInt(document.getElementById('offPicto').value, 10) || 0) * sc;
  const selPictos = [...selectedPictos].filter(n => pictoImages[n]);

  // ── Pomiar wysokości zawartości (bez rysowania) ──
  const hpFontPx = Math.round(5*sc*fsHp);
  const lh = Math.round(hpFontPx * 1.2);

  const nameFontPx = Math.round(17*sc*fsName);
  ctx.font = `bold ${nameFontPx}px system-ui,sans-serif`;

  // Aktualizuj etykiety suwaków (rozmiar w mm)
  const mm = px => (Math.round(px * currentSize / W * 0.53 / 0.05) * 0.05).toFixed(2);
  document.getElementById('fsNameVal').textContent = mm(nameFontPx) + 'mm';
  document.getElementById('fsHpVal').textContent = mm(hpFontPx) + 'mm';
  document.getElementById('fsCompanyVal').textContent = mm(Math.round(7*sc*fsCompany)) + 'mm';
  const pictoVal = document.getElementById('fsPictoVal');
  if (pictoVal) pictoVal.textContent = mm(Math.round(30*sc*fsPicto)) + 'mm';

  ctx.font = `${hpFontPx}px system-ui,sans-serif`;
  const hParagraph = document.getElementById('hPhrases').value.split('\n').filter(Boolean).join(' ');
  const omitP = document.getElementById('omitP') && document.getElementById('omitP').checked;
  const pParagraph = omitP ? '' : document.getElementById('pPhrases').value.split('\n').filter(Boolean).join(' ');
  const sigFontPx = Math.round(8*sc*fsHp);
  const euhParagraph = document.getElementById('euhPhrases').value.split('\n').filter(Boolean).join(' ');

  const pictoSize = selPictos.length > 0 ? Math.round(30 * sc * fsPicto) : 0;

  // ── Kotwice (stałe % wysokości) ──
  const anchorName    = H * 0.12;
  const anchorHp      = H * 0.30;
  const anchorEnPicto = H * 0.72;

  // ── Rysowanie ──

  // Nazwa główna - nazwa produktu podmienia nazwę zapachu (fallback: zapach)
  const fragName = document.getElementById('fragSearch').value;
  const productName = val('productName');
  const mainName = productName || fragName;
  const productLayout = (document.querySelector('input[name="productLayout"]:checked') || {}).value || 'curved';

  ctx.fillStyle = tc;
  ctx.font = `bold ${nameFontPx}px system-ui,sans-serif`;
  if (shape === 'circle' && productLayout === 'curved') {
    const arcRadius = W / 2 - nameFontPx * 0.9;
    drawArcText(ctx, mainName, W/2, W/2 + offName, arcRadius);
  } else {
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(mainName, W/2, anchorName + offName);
  }

  // Flow layout: rysuj GHS po lewej stronie
  let pictoBottom = 0;
  const hpStartY = anchorHp + offHp;
  if (flowLayout) {
    const ghsX = pad;
    const ghsStartY = anchorHp + offGhs;
    let gy = ghsStartY;
    pictos.forEach(name => {
      const img = GHS_IMG[name];
      if (img && img.complete) ctx.drawImage(img, ghsX, gy, iconSize, iconSize);
      gy += iconSize + iconGap;
    });
    pictoBottom = ghsStartY + pictos.length * iconSize + (pictos.length - 1) * iconGap + ghsBottomBuffer;
  }

  // Hasło ostrzegawcze (Art. 20)
  const signalWord = getSignalWord();
  let hpDrawY = hpStartY;
  if (signalWord) {
    const sigCx = flowLayout ? (flowNarrowLeft + flowNarrowRight) / 2 : textCx;
    ctx.textAlign = 'center';
    ctx.font = `bold ${sigFontPx}px system-ui,sans-serif`;
    ctx.fillStyle = signalWord === tr('signal_danger_label') ? '#CC0000' : tc;
    ctx.fillText(signalWord.toUpperCase(), sigCx, hpDrawY);
    hpDrawY += sigFontPx + Math.round(4*sc);
  }

  // Zwroty H i P
  ctx.textAlign = 'center'; ctx.fillStyle = tc;
  ctx.font = `${hpFontPx}px system-ui,sans-serif`;

  if (flowLayout) {
    if (euhParagraph) {
      hpDrawY += wrapTextFlow(ctx, euhParagraph, hpDrawY, lh, flowNarrowLeft, flowNarrowRight, flowFullLeft, flowFullRight, pictoBottom) * lh;
      hpDrawY += Math.round(2*sc);
    }
    if (hParagraph) {
      hpDrawY += wrapTextFlow(ctx, hParagraph, hpDrawY, lh, flowNarrowLeft, flowNarrowRight, flowFullLeft, flowFullRight, pictoBottom) * lh;
    }
    if (pParagraph) {
      hpDrawY += Math.round(2*sc);
      hpDrawY += wrapTextFlow(ctx, pParagraph, hpDrawY, lh, flowNarrowLeft, flowNarrowRight, flowFullLeft, flowFullRight, pictoBottom) * lh;
    }
  } else {
    if (euhParagraph) {
      hpDrawY += wrapText(ctx, euhParagraph, textCx, hpDrawY, textW, lh) * lh;
      hpDrawY += Math.round(2*sc);
    }
    if (hParagraph) {
      hpDrawY += wrapText(ctx, hParagraph, textCx, hpDrawY, textW, lh) * lh;
    }
    if (pParagraph) {
      hpDrawY += Math.round(2*sc);
      hpDrawY += wrapText(ctx, pParagraph, textCx, hpDrawY, textW, lh) * lh;
    }
  }

  // Rysuj piktogramy GHS po bokach, wycentrowane pionowo w etykiecie
  if (hasIcons && !flowLayout) {
    const drawSideIcons = (list, x) => {
      const totalH = list.length * iconSize + (list.length - 1) * iconGap;
      let iy = (H - totalH) / 2 + offGhs;
      list.forEach(name => {
        const img = GHS_IMG[name];
        if (img && img.complete) ctx.drawImage(img, x, iy, iconSize, iconSize);
        iy += iconSize + iconGap;
      });
    };
    drawSideIcons(leftPictos, pad);
    if (rightPictos.length > 0) drawSideIcons(rightPictos, W - pad - iconSize);
  }

  // Piktogramy EN 15494 + tekst ostrzegawczy
  if (selPictos.length > 0) {
    const pictoGap2 = Math.round(4 * sc);
    const totalPW = selPictos.length * pictoSize + (selPictos.length - 1) * pictoGap2;
    let ppx = (W - totalPW) / 2;
    const pictoY = anchorEnPicto + offPicto;
    selPictos.forEach(name => {
      ctx.drawImage(pictoImages[name], ppx, pictoY, pictoSize, pictoSize);
      ppx += pictoSize + pictoGap2;
    });
  }

  // Dane firmy
  const hasGhsPictos = document.querySelectorAll('.ghsCb:checked').length > 0;
  const ufiRaw = document.getElementById('ufi').value.trim();
  const ufiVal = hasGhsPictos ? 'UFI:' + (ufiRaw || 'XXXX-XXXX-XXXX-XXXX') : '';
  const batchUfi = val('batchNum') + (ufiVal ? '          ' + ufiVal : '');
  const addr = val('bizName') + ', ' + val('bizAddr');
  const www = val('bizWww');
  const phoneNum = val('bizPhone');
  const phonePrefix = document.getElementById('bizPhonePrefix');
  const phoneFull = phoneNum ? ((phonePrefix ? phonePrefix.value + ' ' : '') + phoneNum) : '';
  const phone = 'Tel: ' + phoneFull + (www ? '   ' + www : '');
  const massLine = '~' + val('mass') + document.getElementById('unit').value + ' Net';

  ctx.fillStyle = tc;
  const compFontPx = Math.round(7*sc*fsCompany);
  const compFontBoldPx = Math.round(7.5*sc*fsCompany);
  const compLh = Math.round(compFontPx * 1.2);

  const compLayout = (document.querySelector('input[name="companyLayout"]:checked') || {}).value || 'curved';

  if (compLayout === 'curved') {
    let arcR = W * 0.44;
    const compCy = H/2 + offCompany;

    const arcLh = Math.round(compFontPx * 1.4);

    ctx.font = `bold ${compFontBoldPx}px system-ui,sans-serif`;
    drawArcTextBottom(ctx, batchUfi, W/2, compCy, arcR);
    arcR -= arcLh;

    ctx.font = `${compFontPx}px system-ui,sans-serif`;
    ctx.fillStyle = hexToRgba(tc, 0.73);
    drawArcTextBottom(ctx, addr, W/2, compCy, arcR);
    arcR -= arcLh;

    drawArcTextBottom(ctx, phone, W/2, compCy, arcR);
    arcR -= arcLh;

    ctx.font = `bold ${compFontPx}px system-ui,sans-serif`;
    ctx.fillStyle = tc;
    drawArcTextBottom(ctx, massLine, W/2, compCy, arcR);
  } else {
    ctx.textAlign = 'center';
    let cy = H - pad + offCompany;

    ctx.font = `bold ${compFontPx}px system-ui,sans-serif`;
    ctx.fillStyle = tc;
    ctx.fillText(massLine, W/2, cy);
    cy -= compLh;

    ctx.font = `${compFontPx}px system-ui,sans-serif`;
    ctx.fillStyle = hexToRgba(tc, 0.73);
    ctx.fillText(phone, W/2, cy);
    cy -= compLh;

    ctx.fillText(addr, W/2, cy);
    cy -= compLh;

    ctx.font = `bold ${compFontBoldPx}px system-ui,sans-serif`;
    ctx.fillStyle = tc;
    ctx.fillText(batchUfi, W/2, cy);
  }

  ctx.restore();

  // Wymuś przezroczystość poza kształtem (dla eksportu)
  ctx.save();
  ctx.globalCompositeOperation = 'destination-in';
  ctx.beginPath();
  if (shape === 'circle') {
    ctx.arc(W/2, H/2, W/2, 0, Math.PI*2);
  } else {
    ctx.roundRect(0, 0, W, H, 6*sc);
  }
  ctx.fill();
  ctx.restore();

  // Linia cięcia (przerywana) lub obramowanie
  const cutLine = document.getElementById('cutLine').checked;
  if (cutLine) {
    ctx.strokeStyle = '#000000';
    ctx.lineWidth = Math.round(2.5*sc);
    ctx.setLineDash([Math.round(3*sc), Math.round(3*sc)]);
    const inset = Math.round(10*sc);
    if (shape === 'circle') {
      ctx.beginPath(); ctx.arc(W/2, H/2, W/2-inset, 0, Math.PI*2); ctx.stroke();
    } else {
      ctx.beginPath(); ctx.roundRect(inset, inset, W-inset*2, H-inset*2, 6*sc); ctx.stroke();
    }
    ctx.setLineDash([]);
  }

  // ── Ukryj dymek masy jeśli uzupełniono ──
  const massBubble = document.getElementById('massRequiredBubble');
  if (massBubble && document.getElementById('mass').value.trim()) {
    massBubble.style.display = 'none';
  }

  // ── Wskaźnik zgodności CLP ──
  updateClpCompliance(hpFontPx, W);
}

function getClpValidation() {
  const isArt29 = isArt29Applicable();
  const fragName = document.getElementById('fragSearch').value.trim();
  const productName = document.getElementById('productName').value.trim();
  const signalVal = document.getElementById('signalHidden').value || 'none';
  const hasHazards = document.querySelectorAll('.ghsCb:checked').length > 0;
  const hText = document.getElementById('hPhrases').value.trim();
  const pText = document.getElementById('pPhrases').value.trim();
  const euhText = document.getElementById('euhPhrases').value.trim();
  const bizName = document.getElementById('bizName').value.trim();
  const bizAddr = document.getElementById('bizAddr').value.trim();
  const bizPhone = document.getElementById('bizPhone').value.trim();
  const ufiVal = document.getElementById('ufi').value.trim();
  const massStr = document.getElementById('mass').value.trim();
  const massNum = parseFloat(massStr) || 0;

  const checks = [
    { key: 'product_id', required: true, ok: !!(fragName || productName) },
    { key: 'signal', required: hasHazards, ok: signalVal === 'warning' || signalVal === 'danger' },
    { key: 'h', required: hasHazards, ok: hText.length > 0 },
    { key: 'p', required: hasHazards && !isArt29, ok: pText.length > 0 },
    { key: 'contains', required: hasHazards, ok: euhText.length > 0 },
    { key: 'supplier', required: true, ok: !!(bizName && bizAddr && bizPhone.replace(/\D/g,'').length >= 6) },
    { key: 'ufi', required: hasHazards, ok: /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(ufiVal) },
    { key: 'mass', required: true, ok: massStr !== '' && massNum > 0 }
  ];
  const missing = checks.filter(c => c.required && !c.ok).map(c => c.key);
  return { isArt29, hasHazards, checks, missing, allOk: missing.length === 0 };
}

function updateClpCompliance(hpFontPx, W) {
  const el = document.getElementById('clpCompliance');
  if (!el) return;
  const mmPerPx = currentSize / W;
  const fontMm = hpFontPx * mmPerPx;
  const xHeight = fontMm * 0.53;
  const xhDisp = (Math.round(xHeight / 0.05) * 0.05).toFixed(2);
  const isArt29 = isArt29Applicable();

  // GHS icon size on label
  const cMassVal = parseFloat(document.getElementById('mass').value) || 0;
  const cCapacityL = cMassVal / 1000;
  const cMinGhsMm = cCapacityL > 500 ? 46 : cCapacityL > 50 ? 32 : cCapacityL > 3 ? 23 : 10;
  const cMinIconPx = Math.ceil(cMinGhsMm * W / currentSize);
  const cProportionalPx = Math.round(W * 0.15);
  const iconSizePx = Math.max(cMinIconPx, cProportionalPx);
  const ghsMm = (iconSizePx * mmPerPx).toFixed(1);
  const ghsOkMm = cMinGhsMm;
  const ghsOk = parseFloat(ghsMm) >= ghsOkMm;

  el.style.display = '';
  el.className = 'clp-compliance clp-info';

  const ok = '<span style="color:green;font-weight:bold">✓</span>';
  const nok = '<span style="color:red;font-weight:bold">✗</span>';

  // ── Sprawdzenia pól użytkownika ──
  const fragName = document.getElementById('fragSearch').value.trim();
  const productName = document.getElementById('productName').value.trim();
  const productIdOk = !!(fragName || productName);

  const signalVal = document.getElementById('signalHidden').value || 'none';
  const hasHazards = document.querySelectorAll('.ghsCb:checked').length > 0;
  const signalOk = signalVal === 'warning' || signalVal === 'danger';

  const hText = document.getElementById('hPhrases').value.trim();
  const pText = document.getElementById('pPhrases').value.trim();
  const euhText = document.getElementById('euhPhrases').value.trim();
  const hOk = hText.length > 0;
  const pOk = pText.length > 0;
  const containsOk = euhText.length > 0;

  const bizName = document.getElementById('bizName').value.trim();
  const bizAddr = document.getElementById('bizAddr').value.trim();
  const bizPhone = document.getElementById('bizPhone').value.trim();
  const supplierOk = !!(bizName && bizAddr && bizPhone);

  const ufiVal = document.getElementById('ufi').value.trim();
  const ufiOk = /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(ufiVal);

  const massFilled = document.getElementById('mass').value.trim() !== '' && cMassVal > 0;

  const en15494Required = [
    'Nigdy nie zostawiaj płonącej świecy bez nadzoru',
    'Świece należy palić poza zasięgiem przedmiotów łatwopalnych',
    'Przechowywać świece poza zasięgiem dzieci i zwierząt domowych.',
  ];
  const en15494Ok = en15494Required.every(n => selectedPictos.has(n));

  const mark = (cond) => cond ? ok : nok;

  const lines = [];
  lines.push(`<strong>ℹ ${tr('clp_info_title')}</strong>`);
  lines.push(`${tr('clp_info_current')}: ${currentSize}mm ${isArt29 ? '(Art. 29 CLP ≤125ml)' : ''}`);
  lines.push('');
  lines.push(`<strong>${tr('clp_info_on_label')}:</strong>`);
  lines.push(`${mark(productIdOk)} ${tr('clp_info_product_id')}`);
  if (hasHazards) {
    lines.push(`${mark(signalOk)} ${tr('clp_info_signal')}`);
    lines.push(`${mark(ghsOk)} ${tr('clp_info_ghs')}: min. ${ghsOkMm}×${ghsOkMm}mm (${tr('clp_info_yours')}: ${ghsMm}×${ghsMm}mm)`);
    lines.push(`${mark(hOk)} ${tr('clp_info_h')}`);
    if (!isArt29) {
      lines.push(`${mark(pOk)} ${tr('clp_info_p')}`);
    } else {
      lines.push(`${ok} <em>${tr('clp_info_p_leaflet')}</em>`);
    }
    lines.push(`${mark(containsOk)} ${tr('clp_info_contains')}`);
    lines.push(`${mark(ufiOk)} ${tr('clp_info_ufi')}`);
  }
  lines.push(`${mark(supplierOk)} ${tr('clp_info_supplier')}`);
  lines.push(`${mark(massFilled)} ${tr('clp_info_mass')}`);
  lines.push(`${mark(en15494Ok)} ${tr('clp_info_en15494')}`);
  lines.push('');
  const minMm = isArt29 ? 0.5 : 1.2;
  const fontOk = parseFloat(xhDisp) >= minMm - 1e-9;
  const fontColor = fontOk ? 'green' : 'red';
  const fontLabel = isArt29 ? tr('clp_info_font_suggest') : tr('clp_info_size');
  lines.push(`<strong>${tr('clp_info_font_suggestion')}:</strong> ${fontLabel} ≥${minMm}mm (<span style="color:${fontColor};font-weight:bold">${tr('clp_info_yours')}: ${xhDisp}mm ${fontOk ? '✓' : '✗'}</span>)`);
  if (isArt29) {
    lines.push(`<span style="font-size:11px;opacity:0.8">${tr('clp_info_font_readable')}</span>`);
  }
  if (!fontOk && !isArt29) {
    lines.push(`<span style="color:red;font-weight:bold">${tr('clp_font_too_small')}</span>`);
  }
  if (isArt29) {
    lines.push('');
    lines.push(`<strong>Art. 29:</strong> ${tr('clp_info_art29_desc')}`);
  }
  lines.push('');
  lines.push(`<span style="font-size:10px;opacity:0.7">${tr('clp_info_ref')}</span>`);

  // Safe: all values come from tr() static translations and numeric calculations, no user input
  el.innerHTML = lines.join('<br>');
}

// ── EKSPORT ───────────────────────────────────────────────
function getFilename(ext) {
  const frag = (document.getElementById('fragSearch').value || 'etykieta')
    .replace(/[^\w\sąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, '').trim();
  return `CLP_${frag}_${currentSize}mm.${ext}`;
}

function downloadAs(type) {
  const validation = getClpValidation();
  if (!validation.allOk) {
    const massEl = document.getElementById('mass');
    const bubble = document.getElementById('massRequiredBubble');
    if (validation.missing.includes('mass')) {
      massEl.style.border = '2px solid red';
      massEl.focus();
      massEl.addEventListener('input', () => { massEl.style.border = ''; }, { once: true });
    }
    if (bubble) {
      bubble.textContent = tr('export_blocked');
      bubble.style.display = '';
      setTimeout(() => { bubble.style.display = 'none'; }, 4000);
    }
    const complianceEl = document.getElementById('clpCompliance');
    if (complianceEl) complianceEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  const oilName = (document.getElementById('fragSearch') || {}).value || '';
  const hasGhs = document.querySelectorAll('.ghsCb:checked').length > 0;
  const massVal = parseFloat((document.getElementById('mass') || {}).value) || 0;
  TWAnalytics.track('tw_clp_label_generated', {
    oil_name: oilName,
    format: type,
    size_mm: currentSize,
    language: LANG,
    has_ghs: hasGhs,
    mass_g: massVal
  });
  const canvas = document.getElementById('labelCanvas');

  if (type === 'png') {
    const a = document.createElement('a');
    a.href = canvas.toDataURL('image/png');
    a.download = getFilename('png');
    a.click();

  } else if (type === 'svg') {
    const sizeMm = currentSize;
    const dataUrl = canvas.toDataURL('image/png');
    const shape = (document.querySelector('[name=shape]:checked') || {}).value || 'circle';
    let clipDef = '';
    let clipAttr = ' clip-path="url(#labelClip)"';
    if (shape === 'circle') {
      clipDef = `<defs><clipPath id="labelClip"><circle cx="${sizeMm/2}" cy="${sizeMm/2}" r="${sizeMm/2}"/></clipPath></defs>`;
    } else {
      clipDef = `<defs><clipPath id="labelClip"><rect x="0" y="0" width="${sizeMm}" height="${sizeMm}" rx="1"/></clipPath></defs>`;
    }
    const svgContent = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${sizeMm}mm" height="${sizeMm}mm" viewBox="0 0 ${sizeMm} ${sizeMm}">
  ${clipDef}
  <image xlink:href="${dataUrl}" width="${sizeMm}" height="${sizeMm}"${clipAttr}/>
</svg>`;
    const blob = new Blob([svgContent], { type: 'image/svg+xml' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = getFilename('svg');
    a.click();
    URL.revokeObjectURL(a.href);

  } else if (type === 'pdf') {
    if (typeof window.jspdf === 'undefined') {
      const banner = document.getElementById('noSdsBanner');
      banner.textContent = tr('jspdf_error');
      banner.style.display = 'block';
      setTimeout(() => { banner.style.display = 'none'; }, 5000);
      return;
    }
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [currentSize, currentSize] });
    doc.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, currentSize, currentSize);
    doc.save(getFilename('pdf'));
  }
}
